// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2QN_0","filesListContainer":"PosDisputesFiles_filesListContainer__1Neih","filesButton":"PosDisputesFiles_filesButton__12fuI"};